import {
    persistFiltersToStorage,
    buildCategoryMap,
} from './utils/filterStorage'

export default {
    SET_FILTERS(state, { name, value }) {
        state.filters[name] = value
        persistFiltersToStorage(state.filters)
    },
    SET_SELECTED_ITEMS(state, items) {
        state.selectedItems = items || []
    },
    SET_ITEMS(state, items) {
        state.items = items || []
    },
    SET_LOADING(state, loading) {
        state.isLoading = loading
    },
    SET_DIVISIONS(state, divisions) {
        state.divisions = divisions
    },
    SET_CATEGORIES(state, categories) {
        state.categories = categories
        state.categoryMap = buildCategoryMap(categories)
    },
    SET_CATEGORIES_LOADING(state, isLoading) {
        state.isCategoriesLoading = isLoading
    },
    SET_REASONS(state, reasons) {
        state.reasons = reasons
    },

    SET_LAST_KNOWN_STOPPED_COUNT(state, count) {
        state.lastKnownStoppedCount = Number.isFinite(count) ? count : 0
    },
    SET_EXCLUDED_ITEM_IDS(state, itemIds) {
        state.excludedItemIds = itemIds || []
    },

    // ═══════════════════════════════════════════════
    // ПЕЧАТЬ БЛЮД — Mutations
    // ═══════════════════════════════════════════════

    SET_PRINT_LOCATIONS(state, locations) {
        state.printManagement.printLocations = locations
    },

    SET_PRINT_LOCATIONS_LOADING(state, isLoading) {
        state.printManagement.isPrintLocationsLoading = isLoading
    },

    SET_SELECTED_PRINT_LOCATION_IDS(state, ids) {
        state.printManagement.selectedPrintLocationIds = ids
    },

    SET_WORKSHOP_MAPPINGS(state, mappings) {
        state.printManagement.workshopMappings = mappings
    },

    UPDATE_WORKSHOP_MAPPINGS(state, { menuItemIds, workshopIds }) {
        const updatedMappings = [...state.printManagement.workshopMappings]
        menuItemIds.forEach(menuItemId => {
            const existingIndex = updatedMappings.findIndex(
                m => m.menu_item_id === menuItemId
            )
            const newMapping = {
                menu_item_id: menuItemId,
                cooking_workshop_ids: workshopIds,
            }
            if (existingIndex >= 0) {
                updatedMappings[existingIndex] = newMapping
            } else {
                updatedMappings.push(newMapping)
            }
        })
        state.printManagement.workshopMappings = updatedMappings
    },

    SET_NO_PRINT_ITEM_IDS(state, ids) {
        state.printManagement.noPrintItemIds = ids || []
    },

    APPLY_NOT_PRINT_FLAG(state, { menuItemIds, notPrint }) {
        const idSet = new Set(menuItemIds)
        state.items = state.items.map(item => {
            if (item.type !== 'dish' || !idSet.has(item.id)) {
                return item
            }
            return { ...item, notPrint }
        })
    },

    CLEAR_PRINT_MANAGEMENT(state) {
        state.printManagement.printLocations = []
        state.printManagement.selectedPrintLocationIds = []
        state.printManagement.workshopMappings = []
        state.printManagement.noPrintItemIds = []
    },
}
